//////////////////////////////////////
// EXECUTIVE LEADERSHIP GRID

(() => {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {
    const blocks = document.querySelectorAll('.executive-leadership-grid');
    if (!blocks.length) return;

    blocks.forEach(initBlock);
  });

  //////////////////////////////////////
  // INIT

  const initBlock = (block) => {
    const modal   = block.querySelector('.bio-modal');
    const overlay = modal.querySelector('.bio-modal-overlay');
    const closeBtn = modal.querySelector('.bio-modal-close');
    const nameEl  = modal.querySelector('#bio-modal-name');
    const titleEl = modal.querySelector('.bio-modal-info .title');
    const imageEl = modal.querySelector('.bio-modal-image');
    const bodyEl  = modal.querySelector('.bio-modal-body');
    const buttons = block.querySelectorAll('.read-bio');

    //////////////////////////////////////
    // OPEN

    const open = (btn) => {
      const person   = btn.closest('.person');
      const template = person.querySelector('.bio-template');
      const name     = btn.dataset.name || '';
      const position = btn.dataset.position || '';
      const imageUrl = btn.dataset.image || '';

      nameEl.textContent  = name;
      titleEl.textContent = position;
      imageEl.innerHTML   = imageUrl ? `<img src="${imageUrl}" alt="${name}">` : '';
      bodyEl.innerHTML    = template ? template.innerHTML : '';

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };

    //////////////////////////////////////
    // CLOSE

    const close = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    //////////////////////////////////////
    // EVENTS

    buttons.forEach((btn) => btn.addEventListener('click', () => open(btn)));
    overlay.addEventListener('click', close);
    closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  };
})();
